import { ModuleLayout, Tab, TabsGroup } from '@billy/design-system'
import { useCallback, useState } from 'react'

import { BookkeepingCategories } from './elements/BookkeepingCategories'
import { OrganizationInfo } from './elements/OrganizationInfo'
import { RemoteFeatureFlags } from './elements/RemoteFeatureFlags'
import { Scopes } from './elements/Scopes'
import { DebugScreen } from './enums/debugScreen'

export const Debug = () => {
  const [activeTab, setActiveTab] = useState(DebugScreen.OrganizationInfo)

  const setActiveTabHandler = useCallback(
    (tab: DebugScreen) => () => {
      setActiveTab(tab)
    },
    [],
  )

  return (
    <ModuleLayout title="Debug">
      <TabsGroup>
        <Tab
          active={activeTab === DebugScreen.OrganizationInfo}
          icon="zap"
          onClick={setActiveTabHandler(DebugScreen.OrganizationInfo)}
        >
          Organization Info
        </Tab>
        <Tab
          active={activeTab === DebugScreen.BookkeepingCategories}
          icon="briefcaseBusiness"
          onClick={setActiveTabHandler(DebugScreen.BookkeepingCategories)}
        >
          Bookkeeping categories
        </Tab>
        <Tab
          active={activeTab === DebugScreen.Scopes}
          icon="userLock"
          onClick={setActiveTabHandler(DebugScreen.Scopes)}
        >
          Scopes
        </Tab>
        <Tab
          active={activeTab === DebugScreen.RemoteFeatureFlags}
          icon="sparkle"
          onClick={setActiveTabHandler(DebugScreen.RemoteFeatureFlags)}
        >
          Remote feature flags
        </Tab>
      </TabsGroup>

      {(() => {
        switch (activeTab) {
          case DebugScreen.BookkeepingCategories:
            return <BookkeepingCategories />
          case DebugScreen.Scopes:
            return <Scopes />
          case DebugScreen.RemoteFeatureFlags:
            return <RemoteFeatureFlags />
          case DebugScreen.OrganizationInfo:
            return <OrganizationInfo />
          default:
            return null
        }
      })()}
    </ModuleLayout>
  )
}
